export class IssuesFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "containsAnyOf",
            "baseName": "containsAnyOf",
            "type": "Array<IssueType>",
            "format": ""
        },
        {
            "name": "containsNoneOf",
            "baseName": "containsNoneOf",
            "type": "Array<IssueType>",
            "format": ""
        },
        {
            "name": "containsAllOf",
            "baseName": "containsAllOf",
            "type": "Array<IssueType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IssuesFilters.attributeTypeMap;
    }
    constructor() {
    }
}
